'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uid = undefined;

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uid = exports.uid = function uid() {
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  var char = possible.charAt(Math.floor(Math.random() * possible.length));

  return char + (0, _v2.default)();
};

exports.default = {
  uid: uid
};

//# sourceMappingURL=numberUtils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bit/fabfitfun.shared.utils.number-utils/dist/numberUtils.js
// module id = 506
// module chunks = 0